import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { incrementRouterSpaceReactKey } from '~src/spacesPlatform/actions/IncrementRouterSpaceReactKeyAction';
import { CreatedAtDetailSection } from '~src/spacesPlatform/components/content/contentDetailDialog/CommonContentDetailSections';
import { sectionContainer } from '~src/spacesPlatform/components/content/contentDetailDialog/ContentDetailSection';
import { ConnectedDeleteContentSection } from '~src/spacesPlatform/components/content/contentDetailDialog/DeleteContentSection';
import {
  DESCRIPTION_MAX_LENGTH,
  DescriptionDetailSection
} from '~src/spacesPlatform/components/content/contentDetailDialog/DescriptionDetailSection';
import { ConnectedOwnerDetailSection } from '~src/spacesPlatform/components/content/contentDetailDialog/OwnerDetailSection';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { ChangeProjectDescriptionAction } from '../actions/ChangeProjectDescriptionAction';
import { IProjectInfo } from '../models/IProjectInfo';
import { IProjectActions } from '../ServerApi/types/IProjectActions';


interface ProjectDetailsDialogBodyOwnProps {
  readonly project: IProjectInfo;
  readonly allowedActions: IProjectActions;
}

interface ProjectDetailsDialogBodyStateProps {
  readonly urls: SpacesSiteUrls;
}

interface ProjectDetailsDialogBodyDispatchProps {
  readonly incrementRouterSpaceReactKey: () => void;
}

type ProjectDetailsDialogBodyProps =
    ProjectDetailsDialogBodyOwnProps &
    ProjectDetailsDialogBodyStateProps &
    ProjectDetailsDialogBodyDispatchProps;

export function ProjectDetailsDialogBody(props: ProjectDetailsDialogBodyProps): JSX.Element {

  const setDescription = React.useCallback((description: string) => {
    return ChangeProjectDescriptionAction.execute(props.project, description);
  }, [props.project]);


  function allowedAction(actionName: keyof IProjectActions): boolean {
    return !!(props.allowedActions?.[actionName]);
  }

  return (
    <div className={sectionContainer}>
      <DescriptionDetailSection
        description={props.project.description}
        isActionEnabled={allowedAction('setDescription')}
        setDescription={setDescription}
        descriptionMaxLength={DESCRIPTION_MAX_LENGTH}
        showPreviewAndFormattingHints={true}
        showProjectImageHint={true}
        incrementRouterSpaceReactKey={props.incrementRouterSpaceReactKey}
      />
      <ConnectedOwnerDetailSection content={props.project} isActionEnabled={allowedAction('setOwner')} urls={props.urls}/>
      <CreatedAtDetailSection date={props.project.createdAt} />
      {allowedAction('del') &&
        <ConnectedDeleteContentSection
          actionMessage={Messages.deleteProject_action()}
          content={props.project}
        />
      }
    </div>
  );
}

const mapDispatchToProps: MapDispatchToProps<ProjectDetailsDialogBodyDispatchProps> = (dispatch) => bindActionCreators({
  incrementRouterSpaceReactKey: incrementRouterSpaceReactKey
}, dispatch);

const mapStateToProps: MapStateToProps<ProjectDetailsDialogBodyStateProps> = (state: AppState, ownProps: ProjectDetailsDialogBodyOwnProps) => ({
  urls: siteUrlsSelector(state),
});

export const ConnectedProjectDetailsDialogBody: React.ComponentClass<ProjectDetailsDialogBodyOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(ProjectDetailsDialogBody);
